import { render, staticRenderFns } from "./MetricDelta.vue?vue&type=template&id=0c09625a"
import script from "./MetricDelta.vue?vue&type=script&lang=js"
export * from "./MetricDelta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports